import * as t from "io-ts";

export const Pence = t.number;

export type Pence = number;
